<template>
    <ResponsiveDialog
        :value="value"
        @input="$emit('input', $event)"
        :header-title="$t('dashboard.news.titlePill')"
        :full-height="false"
        max-width="480"
    >
        <div class="news-popup__body" v-if="entries.length">
            <Swiper
                ref="swiperRef"
                class="news-popup__swiper"
                :options="swiperOption"
            >
                <swiper-slide v-for="entry in entries" :key="entry.key">
                    <NewsEntry :text="entry.text" :img="entry.img" :img-width-percent="entry.imgWidthPercent || 100"/>
                </swiper-slide>
            </Swiper>

            <!-- Sipky + citac - vzdy viditelne (ne jen na mobilu), umoznuje prolistovat i bez swipe gesta na desktopu.
                 Teckove strankovani by pri desitkach nevidenych novinek (typicky prvni popup po
                 zavedeni funkce) preteklo pres okraj popupu a schovalo sipky - viz
                 docs/superpowers/specs/2026-08-27-changelog-seen-tracking-design.md. -->
            <div class="news-popup__nav" v-if="entries.length > 1">
                <v-btn icon :disabled="activeIndex === 0" @click="$refs.swiperRef.$swiper.slidePrev()">
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <span class="news-popup__counter">{{ activeIndex + 1 }} / {{ entries.length }}</span>
                <v-btn icon :disabled="activeIndex === entries.length - 1" @click="$refs.swiperRef.$swiper.slideNext()">
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </div>
        </div>
    </ResponsiveDialog>
</template>

<script>
    // Popup s nevidenymi novinkami po prihlaseni/nacteni appky (viz App.vue "logged" watcher) -
    // kazdy slide je NewsEntry, stejny blok jako v News.vue (zalozka Novinky). Vsechny predane
    // "entries" uz jsou oznacene jako videne rovnou pri otevirani popupu (App.vue checkUnseenNews) -
    // tady uz se markSeen nevola, prolistovani je cistě navigace, ne podminka pro "videno" (kdo
    // popup zavre driv, nebude jim priste obtezovan tymiz polozkami znovu).
    // Viz docs/superpowers/specs/2026-08-27-changelog-seen-tracking-design.md.
    import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
    import 'swiper/swiper.scss';
    import ResponsiveDialog from '@/components/utils/ResponsiveDialog';
    import NewsEntry from '@/components/dashboard/NewsEntry';

    export default {
        name: 'NewsPopup',
        components: {ResponsiveDialog, NewsEntry, Swiper, SwiperSlide},
        props: {
            value: {type: Boolean, default: false},
            // Predem chronologicky serazene (nejstarsi nevidena -> nejnovejsi), viz changelog/getters unseenEntries.
            entries: {type: Array, default: () => []},
        },
        data() {
            return {
                activeIndex: 0,
                swiperOption: {
                    // Kazda novinka muze mit jinou vysku (s obrazkem/bez) - autoHeight preresizuje kartu podle aktualniho slidu misto pevne vysky.
                    autoHeight: true,
                    spaceBetween: 16,
                },
            }
        },
        watch: {
            // Pri kazdem otevreni zacit od prvni (nejstarsi) nevidene.
            value(isOpen) {
                if (!isOpen) {
                    return;
                }
                this.activeIndex = 0;
                this.$nextTick(() => {
                    this.bindSwiperEvents();
                });
            },
        },
        methods: {
            bindSwiperEvents() {
                const swiper = this.$refs.swiperRef && this.$refs.swiperRef.$swiper;
                if (!swiper) {
                    return;
                }
                // off() nejdriv - watch "value" muze bezet vicekrat (zavrit/znovu otevrit), nechceme duplicitni listenery.
                swiper.off('slideChange', this.onSlideChange);
                swiper.on('slideChange', this.onSlideChange);
            },
            onSlideChange() {
                this.activeIndex = this.$refs.swiperRef.$swiper.activeIndex;
            },
        },
    }
</script>

<style scoped>
    .news-popup__body {
        padding: 8px 16px 70px;
    }

    .news-popup__swiper {
        width: 100%;
    }

    .news-popup__nav {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        margin-top: 8px;
    }

    .news-popup__counter {
        min-width: 56px;
        text-align: center;
        font-variant-numeric: tabular-nums;
        font-weight: 600;
        opacity: .7;
    }
</style>
